import React from "react";
import { PERKS } from "@/data/positions";

export function CareersPerks() {
  return (
    <section className="bg-white border-b border-slate-200">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-slate-200">
        {PERKS.map((p) => (
          <div key={p.label} className="bg-white p-8">
            <p.icon className="h-8 w-8 text-primary-brand" strokeWidth={1.6} />
            <div className="mt-4 font-heading font-black text-lg text-slate-900">{p.label}</div>
            <div className="text-sm text-slate-600 mt-1">{p.desc}</div>
          </div>
        ))}
      </div>
    </section>
  );
}
